module.exports = __webpack_public_path__ + "img/philippines.50f1079c.svg";